import { render } from "./SiteMap.vue?vue&type=template&id=652f107a&scoped=true&ts=true&lang=pug"
import script from "./SiteMap.vue?vue&type=script&lang=ts"
export * from "./SiteMap.vue?vue&type=script&lang=ts"

import "./SiteMap.vue?vue&type=style&index=0&id=652f107a&scoped=true&lang=css"
/* custom blocks */
import block0 from "./SiteMap.vue?vue&type=custom&index=0&blockType=i18n&locale=en"
if (typeof block0 === 'function') block0(script)
import block1 from "@/locale/es/components/sitemap.json?vue&type=custom&index=1&blockType=i18n&issuerPath=%2Ftarball%2Fsrc%2Fviews%2FSiteMap.vue&locale=es"
if (typeof block1 === 'function') block1(script)


import exportComponent from "/tarball/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-652f107a"]])

export default __exports__